export default __webpack_public_path__ + "static/media/Event1.38fd27c4.jpeg";